import React from 'react';
import './SidebarMenu.css';

const SidebarMenu = ({ children }) => {
    return (
        <nav className="sidebar-menu">
            {children}
        </nav>
    );
};

export default SidebarMenu;
